module.exports = __webpack_public_path__ + "img/BANNER_VEH_PAG NUEVA.8cb42764.png";